// extracted by mini-css-extract-plugin
module.exports = {"landing":"Landing_landing__2YwRv","btn":"Landing_btn__2p-Pb"};